import loadable from '@loadable/component';

import routeRules from './routeRules';

const routesData = [
  {
    path: routeRules.landingPage,
    component: loadable(() => import('../Container/Login')),
    auth: false,
    exact: true,
  },
  {
    path: routeRules.termsandconditions,
    component: loadable(() => import('../Container/termsandconditions')),
    auth: false,
    exact: true,
  },
  {
    path: routeRules.audiovideocalls,
    component: loadable(() => import('../Container/SendbirdCalling')),
    auth: false,
    exact: true,
  },
  {
    path: routeRules.dashboard,
    component: loadable(() => import('../Container/analytics')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.usermanagement,
    component: loadable(() => import('../Container/Usermanagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.dreamanagement,
    component: loadable(() => import('../Container/Dreamanagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.dreamPartnerManagement,
    component: loadable(() => import('../Container/DreamPartnerManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.reportmanagement,
    component: loadable(() => import('../Container/Subsmanagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.PushNotification,
    component: loadable(() => import('../Container/NotiUsermanagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.subscriptioninfo,
    component: loadable(() => import('../Container/SubscriptionDetail')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.Supportmanagement,
    component: loadable(() => import('../Container/Supportmanagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.supportdetails,
    component: loadable(() => import('../Container/Supportmanagement/SupportDetails')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.messageManagement,
    component: loadable(() => import('../Container/MessageManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.messagedetails,
    component: loadable(() => import('../Container/MessageManagement/MessageDetails')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.PremiumUser,
    component: loadable(() => import('../Container/UsePremiumrmanagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.BloomUser,
    component: loadable(() => import('../Container/UserBloomManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.FreeUser,
    component: loadable(() => import('../Container/UseFreeManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.FreeUserSubscriptionList,
    component: loadable(() => import('../Container/UseFreeManagement/UserFreeList')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.UserSubscriptionList,
    component: loadable(() => import('../Container/UsePremiumrmanagement/UserSubscriptionList')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.UserBloomList,
    component: loadable(() => import('../Container/UserBloomManagement/UserBloomList')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.analytics,
    component: loadable(() => import('../Container/analytics')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.userdetails,
    component: loadable(() => import('../Container/UserDetails')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.InfluencerUser,
    component: loadable(() => import('../Container/DomainInfo')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.Referralmanagement,
    component: loadable(() => import('../Container/Referralmanagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.influencerDetails,
    component: loadable(() => import('../Container/DomainInfo/DomainDetails')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.editInfluencerUser,
    component: loadable(() => import('../Container/DomainInfo/EditDomainInfo')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.PremiumPackage,
    component: loadable(() => import('../Container/PremiumPackagesManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.BloomPackage,
    component: loadable(() => import('../Container/BloomPackagesManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.contentmanagement,
    component: loadable(() => import('../Container/ContentManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.ethnicityManagement,
    component: loadable(() => import('../Container/EthnicityManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.noticontent,
    component: loadable(() => import('../Container/NotiContentManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.addoredituser,
    component: loadable(() => import('../Container/Usermanagement/AddorEditUser')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.addoreditethnicity,
    component: loadable(() => import('../Container/EthnicityManagement/AddorEditEthnicity')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.AddorEditPackage,
    component: loadable(() => import('../Container/PremiumPackagesManagement/AddorEditPackage')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.AddorEditPackages,
    component: loadable(() => import('../Container/BloomPackagesManagement/AddorEditPackages')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.addoreditdream,
    component: loadable(() => import('../Container/Dreamanagement/AddorEditDream')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.addoreditdreampartner,
    component: loadable(() => import('../Container/DreamPartnerManagement/AddorEditDreamPartner')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.addoreditrelation,
    component: loadable(() => import('../Container/RelationshipManagement/AddorEditRelation')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.addoreditintersted,
    component: loadable(() => import('../Container/InterstedManagement/AddorEditIntersted')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.addoredithobbies,
    component: loadable(() => import('../Container/HobbiesManagement/AddorEditHobbies')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.addoreditmyself,
    component: loadable(() => import('../Container/MySelfManagement/AddorEditmyself')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.addorediteducation,
    component: loadable(() => import('../Container/EducationManagement/AddorEditEducation')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.addoreditreligion,
    component: loadable(() => import('../Container/ReligionManagement/AddorEditReligion')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.addoreditimportancereligion,
    component: loadable(() => import('../Container/ImportanceReligionManagement/AddorEditImportanceReligion')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.profile,
    component: loadable(() => import('../Container/Profile/index')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.appVersion,
    component: loadable(() => import('../Container/AppVersion/index')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.scandetails,
    component: loadable(() => import('../Container/ScanDetails')),
    auth: true,
    exact: true,
  },

  {
    path: routeRules.forget,
    component: loadable(() => import('../Container/forgetpass')),
    auth: false,
    exact: true,
  },
  {
    path: routeRules.resetpassword,
    component: loadable(() => import('../Container/resetpass')),
    auth: false,
    exact: true,
  },
  {
    path: routeRules.resetadminpassword,
    component: loadable(() => import('../Container/resetadminpassword')),
    auth: false,
    exact: true,
  },
  {
    path: routeRules.verifyMail,
    component: loadable(() => import('../Container/verifyMail')),
    auth: false,
    exact: true,
  },
  {
    path: routeRules.dreamdetails,
    component: loadable(() => import('../Container/DreamDetails')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.relationshipmanagement,
    component: loadable(() => import('../Container/RelationshipManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.interstedmanagement,
    component: loadable(() => import('../Container/InterstedManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.hobbiesmanagement,
    component: loadable(() => import('../Container/HobbiesManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.myselfmanagement,
    component: loadable(() => import('../Container/MySelfManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.educationmanagement,
    component: loadable(() => import('../Container/EducationManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.importanceReligionManagement,
    component: loadable(() => import('../Container/ImportanceReligionManagement')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.inviteFriends,
    component: loadable(() => import('../Container/InviteFriends')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.usersFeedback,
    component: loadable(() => import('../Container/UsersFeedback')),
    auth: true,
    exact: true,
  },
  {
    path: routeRules.religionnmanagement,
    component: loadable(() => import('../Container/ReligionManagement')),
    auth: true,
    exact: true,
  },
];

export default routesData;
